import React from 'react';
import { Modal } from 'react-bootstrap';

const ConfirmationModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title, 
  message, 
  messageHTML, 
  showCancelButton = true, 
  size = "", 
  onconfirmname = "OK", 
  oncancelname = "", 
  closeButton = true 
}) => {
  return (
    <Modal className='modal-popup' show={show} onHide={onHide} centered size='md' backdrop="static" keyboard={false} >
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p dangerouslySetInnerHTML={{ __html: messageHTML }}></p>
        <h5 className='font-size-16 fw-0'>{message}</h5>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-success" onClick={onConfirm}>
          {onconfirmname}
        </button>
        {showCancelButton && (
          <button className="btn btn-danger" onClick={onHide}>
            {oncancelname}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
